import { useLang } from '../i18n/LangProvider'
import { t } from './i18n'

// 2026-10-23: antes sin idioma, así que salía siempre en euskera.
export function SinAcceso() {
  const lang = useLang()
  return (
    <div>
      <h2>{t('sinAcceso', lang)}</h2>
      <p>{t('sinAccesoMensaje', lang)}</p>
    </div>
  )
}
